import React from 'react';

const SideArrowUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.98 5.73h8.04c.556 0 .835.671.44 1.065l-4.018 4.022a.626.626 0 0 1-.884 0L3.539 6.795a.624.624 0 0 1 .44-1.066Z"
    />
  </svg>
);
export default SideArrowUp;
